import { creatorbase } from '@round/api';
import { buildInstagramUserUrl, buildTiktokUserUrl } from 'helpers';
import TruncatedText from '../TruncatedText/TruncatedText';

const profileUrlBuilders: Record<creatorbase.CreatorBulkUploadItemPlatform, (handle: string) => string> = {
    instagram: buildInstagramUserUrl,
    tiktok: buildTiktokUserUrl,
};

type Props = {
    platform: creatorbase.CreatorBulkUploadItemPlatform;
    handle: string;
};

/** The handle, linking to its profile on the platform, truncated with the whole of it in a tooltip. */
const ProfileLink = ({ platform, handle }: Props) => (
    <TruncatedText text={handle} href={profileUrlBuilders[platform](handle)} />
);

export default ProfileLink;
